import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(({ $store, $global, $project }) => {
  $store.$global = $global
  $store.$project = $project
})
